import { render } from "./AddCouponPage.vue?vue&type=template&id=96cf71f2&ts=true"
import script from "./AddCouponPage.vue?vue&type=script&lang=ts"
export * from "./AddCouponPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__